import React from 'react';
import PropTypes from 'prop-types';
import Media from './Media';
import MediaSkeleton, {
	MediaSkeletonContainerClasses
} from '../skeleton/MediaSkeleton';

const MediaContainer = ({
	shouldFullyRenderCard,
	enableFirstSkeletonImg,
	ssrPlaceholderImage,
	...props
}) => (
	<div
		className={`vehicle-card-media-container${
			!shouldFullyRenderCard
				? ` ${MediaSkeletonContainerClasses.join(' ')}`
				: ''
		}`}
	>
		{shouldFullyRenderCard ? (
			<Media {...props} ssrPlaceholderImage={ssrPlaceholderImage} />
		) : (
			<MediaSkeleton
				enableFirstSkeletonImg={enableFirstSkeletonImg}
				placeholderImage={ssrPlaceholderImage}
			/>
		)}
	</div>
);

MediaContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool.isRequired,
	enableFirstSkeletonImg: PropTypes.bool,
	ssrPlaceholderImage: PropTypes.string
};

export default MediaContainer;
